var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h12v12H0z","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M7.4 4.5L6 0 4.6 4.5H0l3.665 2.753L2.22 11.7 6 8.955 9.78 11.7 8.335 7.253 12 4.5z","key":1})]));
}

Star.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Star;

Star.default = Star;
